import React from 'react';
import PropTypes from 'prop-types';
// import { useSelector } from 'react-redux';

import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';

const UnregisteredPage = function () {
  // const rlgCd = useSelector((state) => state.reserve.lgCd);
  // const rcLgCd = useSelector((state) => state.reserveChange.lgCd);

  // const lgCd = rlgCd || rcLgCd;

  // const uri = new URL(window.location.href);
  // const { protocol = '', host = '' } = uri;
  // // const topUrl = `${protocol}//${host}/reserve/${lgCd}`;

  return (
    <>
      <Header />
      <div id="container">
        <div id="contents">
          <div className="inner450">
            <p>予約サービスを利用できません。</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

UnregisteredPage.propTypes = {
  error: PropTypes.shape({ message: PropTypes.string }).isRequired,
};

export default UnregisteredPage;
